import { render } from "./SettingOtAllIn.vue?vue&type=template&id=365896c5&scoped=true"
import script from "./SettingOtAllIn.vue?vue&type=script&lang=js"
export * from "./SettingOtAllIn.vue?vue&type=script&lang=js"

import "./SettingOtAllIn.vue?vue&type=style&index=0&id=365896c5&scoped=true&lang=css"
import "./SettingOtAllIn.vue?vue&type=style&index=1&id=365896c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365896c5"]])

export default __exports__